import { render, staticRenderFns } from "./SxswScraperIndex.vue?vue&type=template&id=4ec545c7&"
import script from "./SxswScraperIndex.vue?vue&type=script&lang=js&"
export * from "./SxswScraperIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports